/**
 * @param  {Object} props
 * @return {Object}
 */
export default function translatePropsIntoFontSize(props) {
  switch (props.size) {
    case "large":
    case "small":
    default:
      return {
        fontSize: 14,
        fontWeight: 500,
        letterSpacing: 0.5,
        lineHeight: 1.14,
      };
    case "xsmall":
      return {
        fontSize: 12,
        fontWeight: 500,
        letterSpacing: 0.4,
        lineHeight: 1.33,
      };
  }
}
